import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from "react-router-dom";
import AskExpert from './../components/askExpert';
import { SamplesActions } from './../actions';
import { Swiper, SwiperSlide } from 'swiper/react';
import LoadingBar from 'react-top-loading-bar';

import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import Api from './../api/api.js';

import arr from './../assets/img/collection-list-arrow-up.svg';


import img7 from './../assets/img/collection-sp-7.png';

import SwiperCore, { Navigation } from 'swiper';
// install Swiper modules
SwiperCore.use([Navigation]);



class CollectionSinglePage extends React.Component {


    swiperBreakpoint = {
        // when window width is >= 320px
        320: {
            slidesPerView: 1.5,
            spaceBetween: 20
        },
        // when window width is >= 480px
        767: {
            slidesPerView: 1.5,
            spaceBetween: 30
        },
        // when window width is >= 640px
        1199: {
            slidesPerView: 2,
            spaceBetween: 100
        }
    }

    state={
        data:'',
        listOpen: false,
        ref:React.createRef(null)
    }

    
    getProjectId = () => {
        const {id} = this.props.match.params;
        return id;
    }

    componentDidMount(){
        document.title ="Collection / Cerafini";
        document.getElementById("fav-icon").href = process.env.PUBLIC_URL + "/CERAFINI_Collection.png";
        const {ref} = this.state;
        ref.current.continuousStart(10);

        const id = this.getProjectId();

        Api.getCollectionSinglePage(id).then((response)=>{
            this.setState({data: response.data});
            ref.current.complete();
        })
    }

    renderHeroSection = (data) => {
        const {langTxt}=this.props;
        return(
            <div className='collection-single-page-hero'>
                {(data.visibility)? 
                    <> 
                        <div className="hero-image">
                        <img src={data.image_url} alt="hero-img"/>
                        </div>
                        <div className="hero-text">
                            <p>{data["title_"+langTxt]}</p>
                            <h1>{data["secondary_title_"+ langTxt]}</h1>
                            <p className="desc">{data["description_"+ langTxt]}</p>
                        </div>
                    </>
                :''}
            </div>
        )
    }

    renderSlider = (data) => {
          return (
            <Swiper
            spaceBetween={100}
            slidesPerView={2}
            loop="true"
            navigation={{hideOnClick: true}}
            breakpoints={this.swiperBreakpoint}
            >
               {data.map((image,i)=>{
                return <SwiperSlide><img src={image.image_url} alt={"slider " +i} className="slider-image"/></SwiperSlide>
              })} 
            </Swiper>
          );
    }

    renderModuleOne = (data) => {
        const {langTxt}=this.props;

        return (
            <>
            {(data[0].visibility)? <div className="module-one">
                <div className="module-one-left">
                    <img src={data[0].image_url} alt="img"/>
                    <div className="module-one-left-desc" dangerouslySetInnerHTML={this.createMarkup(data[0]["image_info_"+langTxt])}/>
                </div>
                <div className="module-one-right">
                    <div className="module-one-right-desc" dangerouslySetInnerHTML={this.createMarkup(data[1]["image_info_"+langTxt])}/>
                    <img src={data[1].image_url} alt="img"/>
                </div>
            </div>:''}
               
            </>
        )
    }

    renderModuleTwo = (data) =>{
        const {langTxt}=this.props;

        return(
            <>
                {(data.visibility)? <div className="module-two">
                    <div className="module-two-wrapper">
                        <div className="module-two-desc">
                            <h2 className="module-two-desc-title">{data["title_"+langTxt]}</h2>
                            <p className="module-two-desc-text">{data["description_"+ langTxt]}</p>
                            <div className="btn-wrapper btn-style">
                                <Link to={data.btn_link}>{data["btn_"+ langTxt]}</Link>
                            </div>
                        </div>
                        <div className="module-two-img">
                            <img src={data.image_url} alt=""/>
                        </div>
                    </div>
                </div> : ''}
            </>
        )
    }

    renderModuleTwoTypeTwo = (data) => {
        const {langTxt}=this.props;
        
        return (
            <>
                {(data.visibility)? <div className="module-two-type-b">
                    <div className="module-two-type-b-wrapper">
                        <div className="module-two-type-b-desc">
                            <h2 className="module-two-type-b-desc-title">{data["title_"+langTxt]}</h2>
                            <p className="module-two-type-b-desc-text"  dangerouslySetInnerHTML={this.createMarkup(data["description_"+langTxt])}/>
                        </div>
                        <div className="module-two-type-b-img">
                            <img src={data.image_url} alt=""/>
                        </div>
                    </div>
                </div> : ''}
            </>
        )
    }

    createMarkup = (data) => {
        return {__html: data};
    }

    renderModuleFour = (data) => {
        const {langTxt}=this.props;
        
        return (
            <>
                {(data.visibility)? <div className="module-four">
                    <div className="module-four-img">
                    <img src={data.image_url} alt=""/>
                    </div>
                    <div className="module-four-desc">
                        <div className="module-four-desc-title">
                            <p>{data["title_"+langTxt]}</p>
                            <h3>{data["secondary_title_"+ langTxt]}</h3>
                        </div>
                        <div className="module-four-desc-text">
                            <div className="left" dangerouslySetInnerHTML={this.createMarkup(data["description_"+ langTxt])}/>
                        </div>
                    </div>
                </div> :''}
               
            </>
        )
    }

    renderModuleFourTypeTwo = (data) => {
        const {langTxt}=this.props;

        return(
            <>
                {(data[0].visibility)? <div className="module-four-type-b">
                    <div className="module-four-type-b-img">
                    <img src={data[1].image_url} alt=""/>
                    </div>
                    <div className="module-four-type-b-desc">
                        <div className="module-four-type-b-desc-title">
                            <h3>{data[0]["title_"+ langTxt]}</h3>
                            <div>
                                <img src={data[0].image_url} alt="img"/>
                                <p dangerouslySetInnerHTML={this.createMarkup(data[0]["description_"+ langTxt])}/>
                            </div>
                        </div>
                    </div>
                </div> :''}
            </>
        )
    }    

    addSamples = (e, sample) => {
        e.preventDefault();
        this.props.addSample(sample);
        this.props.openSamples(true);
    }

    renderModuleFive = (data) => {
        const {listOpen} = this.state;
        const {langTxt} = this.props;
        const collectionName = this.state.data.hero_collection_module["title_" + langTxt];
        const floorColors = data[0].floor_colors.map((color, i)=>{
            return{
                id: i,
                image_url:color.image_url,
                title:color["name_" + langTxt],
                collection: collectionName,
                type: color.type
            }
        })
        
        const wallColors = data[0].wall_colors.map((color, i)=>{
            return{
                id: i,
                image_url:color.image_url,
                title:color["name_" + langTxt],
                collection: collectionName,
                type: color.type
            }
        })
        
       
        return (
            <div className="collection-details">
                <div className="collection-details-title">
                    <div className="title-wrapper">
                        <p>Colors</p>
                        <h3>Choose the colors you would like to add to your sample list.</h3>
                    </div>
                </div>
                <div className="detail-select">
                {(floorColors.length > 0)? 
                    <div className="floor-colors">
                        <div className="left">
                            <p>Floor Colors</p>
                        </div>
                        <div className="right">
                            {/* map data */}
                            {floorColors.map((sample)=>(
                                <div className="right-item cursor-pointer" onClick={(e)=>this.addSamples(e, sample)}>
                                    <img src={sample.image_url} alt=""/>
                                    <p>{sample.title}</p>
                                    <div className="add-sample-div"><span className="add-sample">{(langTxt === "en")? 'Add to Sample': 'Ajouter à l\'échantillon'}</span></div>
                                </div>
                            ))}
                        </div>
                    </div>
                : ''}
                    {(wallColors.length > 0)? 
                        <div className="wall-colors">
                        <div className="left">
                            <p>Wall Colors</p>
                        </div>
                        <div className="right">
                            { (wallColors.length > 0)? wallColors.map((sample)=>(
                                <div className="right-item cursor-pointer" onClick={(e)=>this.addSamples(e, sample)}>
                                    <img src={sample.image_url} alt=""/>
                                    <p>{sample.title}</p>
                                    <div className="add-sample-div"><span className="add-sample">{(langTxt === "en")? 'Add to Sample': 'Ajouter à l\'échantillon'}</span></div>
                                </div>
                            )): ''}
                        </div>
                    </div>
                    :'' }
                   
                    <div className={`product-details cursor-pointer ${listOpen? 'opened': ''}`}  onClick={()=>this.setState({listOpen: !listOpen})}>
                        <div className={"product-details-title"}>
                            <p>{(langTxt === "en")? 'Product Details': 'Détails du produit'}</p>
                            <div className="arrow">
                                <img src={arr} alt=""/>
                            </div>
                        </div>
                        {listOpen? 
                            <div className="product-details-list">
                                <span dangerouslySetInnerHTML={this.createMarkup(data[0]["details_"+langTxt])}/>
                            </div>

                        : ""
                        }
                       
                    </div>
                </div>
            </div>
        )
    }

    renderCatalogue = (data, langTxt) => {

        return (
            <div className="catalogue-wrapper">
                <img src={data.image_url} alt=""/>
                <h3>{data["title_"+langTxt]}</h3>
                <div className="btn-wrapper btn-style">
                    <a href={data.btn_link} target="_blank">{data["btn_"+langTxt]}</a>
                </div>
            </div>
        )
    }

    renderImageInCatalogueSection = (data, langTxt) => {
        return(
            <div>
                <img src={data.image_url} alt=""/>
            </div>
        )
    }

    renderCatalogueSection = (data) => {
        const {langTxt} = this.props;
        return(
            <>
            {(data[0].visibility)? <div className="catalogue">
                <h3 className="catalogue-title">COLLECTION <br/>CATALOGUE </h3>
                <div className="catalogue-section">
                    <div className="catalogue-container">
                        {this.renderCatalogue(data[0],langTxt)}
                    </div>
                    <div className="catalogue-container1">
                        {this.renderImageInCatalogueSection(data[1],langTxt)}
                    </div>
                </div>
            </div> : ''}
            </>
        )
    }



    render (){
        const {data}= this.state;
        return(
            <div className="collection-single-page page">
            <LoadingBar color='#000' height={4} ref={this.state.ref} />
            {(data)? <>
                {this.renderHeroSection(data.hero_collection_module)}
                {this.renderModuleOne(data.first_collection_module)}
                {this.renderModuleTwo(data.second_collection_module_type_one)}
                {this.renderModuleTwoTypeTwo(data.second_collection_module_type_two)}
                <div className="mid-page-img">
                    <img src={data.third_collection_module.image_url} alt=""/>
                </div>
                <div className="slider-no-slider">
                    {this.renderSlider(data.fourth_collection_module)}
                </div>
                {this.renderModuleFour(data.fifth_collection_module_type_one)}
                {this.renderModuleFourTypeTwo(data.fifth_collection_module_type_two)}
                {this.renderModuleFive(data.details_collection_module)}
                {this.renderCatalogueSection(data.sixth_collection_module)}
                <AskExpert/>
            </> :''}
               
            </div>
        );
    }
}


// what props do i need to get from the state for this component?
const mapStateToProps = (state) => {
    // get the props needed for this component from the state of the store.
    return {
        langTxt: (state.lang && state.lang.text) || 'en',
        langUrl: (state.lang && state.lang.url) || '',
    }
}

// what events will occur that will change the state in this component
const mapDispatchToProps = (dispatch) => {
    return {
        addSample: (sample) => dispatch(SamplesActions.add(sample)),
        openSamples: (isOpened) => dispatch(SamplesActions.open(isOpened))
    };
};

export default withRouter( connect(mapStateToProps, mapDispatchToProps)(CollectionSinglePage) );

